module.exports = __webpack_public_path__ + "static/media/Img_hero_investOpts.4aabd0c3.jpg";